import { useCallback, useEffect, useMemo } from 'react';
import { resolveParentOrigin } from '../utils/iframeBridge';

function useIframeBridge(vzgptEnabled, iframeId) {
  const parentOrigin = useMemo(() => resolveParentOrigin(), []);

  useEffect(() => {
    if (!vzgptEnabled || !iframeId) return;

    const observer = new ResizeObserver(() => {
      window.parent.postMessage(
        {
          type: 'RESIZE_IFRAME_WIDGET',
          iframeId,
          height: document.documentElement.scrollHeight,
        },
        parentOrigin
      );
    });

    observer.observe(document.documentElement);

    return () => observer.disconnect();
  }, [iframeId, vzgptEnabled, parentOrigin]);

  const close = useCallback(() => {
    if (!vzgptEnabled || !iframeId) return;

    window.parent.postMessage(
      {
        type: 'CLOSE_IFRAME_WIDGET',
        iframeId,
      },
      parentOrigin
    );
  }, [iframeId, vzgptEnabled, parentOrigin]);

  return { close };
}

export default useIframeBridge;
